module.exports = __webpack_public_path__ + "img/sancho_kaiun_logo.74fd6d94.jpg";